import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion, Button, Spinner } from "react-bootstrap";
import {
  removeSelectedField,
  clearSelectedField,
  addedField,
} from "../../configurations/redux-configurations/actions/fieldAction";
import ConfirmPopup from "./ConfirmPopup";
import Alert from "../common/Alert";
import GoogleMapHelper from "../../helpers/GoogleMapHelper";
import SessionHelper from "../../helpers/SessionHelper";
import _ from "lodash";
import FluentdHelper from "../../helpers/FluentdHelper";

import {
  LOGERROR,
  AVAILABLE,
  SELECTED,
  DANGER,
  SUCCESSFUL_REGISTRATION,
  ADDED_FIELDS,
  REGISTERED_FIELDS,
  CLAIMED_FIELDS,
  CLAIM_IDS,
  EMPTY,
} from "../../configurations/Constants";
import {
  ERROR_WHILE_LOG_IN,
  FIELD_ALREADY_REGISTERED,
  SHARED_FIELD_WITH_OTHER_USER,
  CONTACT_ADMIN_TO_DELETE_FIELD,
  ERROR_WHILE_DELETING_FIELD,
  REMOVE_SELECTED_FIELD_CONFIRMATION,
  REMOVE_REGISTERED_FIELD_CONFIRMATION,
  REMOVE_CLAIMED_FIELD_CONFIRMATION,
  ERROR_WHILE_MAKING_REQUEST,
  ADDED_FIELDS_WARNING,
  ERROR_WHILE_REGISTERING_FIELD,
} from "../../configurations/MessageConstants";
import StorageHelper from "../../helpers/StorageHelper";
import UserService from "../../api-service/UserService";
import PanelAddedField from "./PanelAddedField";
import PanelRegisteredField from "./PanelRegisteredField";
import PanelClaimedField from "./PanelClaimedField";
import LoadingOverlay from "../common/LoadingOverlay";
import { StatusCodes } from "../../configurations/status-codes";

function RegisterPanel(props) {
  const dispatch = useDispatch();
  const AddedFields = useSelector((state) => state.field.addedFields);
  const SelectedFieldAdded = useSelector(
    (state) => state.field.selectedFieldAdded
  );
  const AllPolygons = useSelector((state) => state.field.allPolygons);
  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  const registeredUser = useSelector((state) => state.user.registeredUser);

  const [btnSubmitClick, setBtnSubmitClick] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [confirmPopupMessage, setConfirmPopupMessage] = useState(EMPTY);
  const [errorMessage, setErrorMessage] = useState(EMPTY);
  const [irrig_unit_Id, setIrrig_unit_Id] = useState(EMPTY);
  const [index, setIndex] = useState(EMPTY);
  const [header, setHeader] = useState(EMPTY);
  const [fieldId, setFieldId] = useState(EMPTY);
  const [guid, setGuid] = useState(EMPTY);
  const [submitError, setSubmitError] = useState(false);
  const [claimId, setClaimId] = useState(EMPTY);
  const [claimIrrigUnitId, setClaimIrrigUnitId] = useState(EMPTY);
  const [toggleArrow, setToggleArrow] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState(false);
  const [noActionRequired, setNoActionRequired] = useState(true);
  const [editRecord, setEditRecord] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [openedPanel, setOpenedPanel] = useState(ADDED_FIELDS);

  /*Sidebar Animation*/

  const handleEmptyStringsInJson = (object) => {
    let jsonString = JSON.stringify(object);
    let myjson = jsonString.replace(/" "|EMPTY/g, 0);
    return JSON.parse(myjson);
  };

  const _handle_submit_registration_request = async () => {
    await SessionHelper.handleRefreshToken();
    setBtnSubmitClick(true);
    let field_details = [];
    for (let j = 0; j < AddedFields.length; j++) {
      let wells = [];
      for (let i = 0; i < AddedFields[j].wells.length; i++) {
        let well = AddedFields[j].wells[i];
        wells.push({
          well_id: well.well_id,
          pump_rate: well.gpm,
          updated_pump_rate: parseInt(well.ugpm),
          active: well.active,
          isElectricWell: well.isElectricWell,
        });
      }

      let field = {
        field_name: AddedFields[j].fieldName,
        irrig_unit_id: AddedFields[j].irrigUnit.properties.irrig_unit_id,
        business_name: AddedFields[j].businessName,
        farm_name: AddedFields[j].farmName,
        well_data: wells,
        surfaceWaterPercentage: AddedFields[j].surfaceWaterPercentage,
        groundWaterPercentage: AddedFields[j].groundWaterPercentage,
      };
      field = handleEmptyStringsInJson(field);
      field_details.push(field);
    }

    let payload = {};
    try {
      payload = {
        fields: field_details,
      };
      await handle_request_submit(payload);
    } catch (error) {
      console.error(ERROR_WHILE_LOG_IN, error);
      setBtnSubmitClick(false);
      setSubmitError(true);
      setErrorMessage(ERROR_WHILE_LOG_IN);
    }
  };

  const handle_request_submit = async (payload) => {
    try {
      await UserService.submitAddedFields(payload);
      dispatch(clearSelectedField());
      props.removeWells();
      if (StorageHelper.getItem(SUCCESSFUL_REGISTRATION) === "true") {
        props.isRegistrationSucessful(true);
        StorageHelper.removeItem(SUCCESSFUL_REGISTRATION);
        setBtnSubmitClick(false);
        await props.reloadRegistrationFields(payload.fields);
      } else {
        setBtnSubmitClick(false);
        await props.reloadRegistrationFields(payload.fields);
      }
    } catch (error) {
      let errorMessage = EMPTY;
      let user_email = loggedInUser || registeredUser;
      let responseData = error.response.data;
      console.error(ERROR_WHILE_REGISTERING_FIELD, error);
      if (
        responseData.message.includes("Field with Tp_id") &&
        responseData.message.includes("already registered")
      ) {
        errorMessage = FIELD_ALREADY_REGISTERED;
      } else {
        errorMessage = responseData.message;
      }
      setBtnSubmitClick(false);
      setSubmitError(true);
      setErrorMessage(
        error.response.status === StatusCodes.BAD_REQUEST
          ? errorMessage
          : ERROR_WHILE_MAKING_REQUEST
      );

      FluentdHelper.logEvent(
        ERROR_WHILE_REGISTERING_FIELD,
        "RegisterPanel_handle_request_submit",
        user_email,
        {
          response:
            error.response.status === StatusCodes.BAD_REQUEST
              ? responseData
              : error,
        },
        LOGERROR
      );
    }
  };

  const performWarningAction = async () => {
    if (irrig_unit_Id !== EMPTY) {
      for (let i = 0; i < AddedFields.length; i++) {
        if (AddedFields[i].irrig_unit_Id === irrig_unit_Id) {
          let layer = props.getLayerByIrrigUnitId(AddedFields[i].irrig_unit_Id);
          layer.setAttribute("fill", AVAILABLE);
          break;
        }
      }
      dispatch(removeSelectedField(irrig_unit_Id, index));
      props.removeWells();
      setIrrig_unit_Id(EMPTY);
      setIndex(EMPTY);
      setShowConfirmPopup(false);
      setHeader(EMPTY);
      setDeleteRecord(false);
      setEditRecord(false);
    } else if (fieldId !== EMPTY && guid !== EMPTY) {
      await _handle_request_delete_field(fieldId);
    } else if (claimId !== EMPTY) {
      _handle_delete_claimed_field(claimId);
    }
  };

  const _handle_request_delete_field = async (field_id) => {
    let user_email = loggedInUser || registeredUser;
    try {
      await UserService.deleteRegisteredField(field_id);
      setGuid(EMPTY);
      setFieldId(EMPTY);
      setShowConfirmPopup(false);
      setDeleteRecord(false);
      setOverlayLoading(true);
      dispatch(clearSelectedField());
      props.removeWells();
      window.location.reload();
    } catch (error) {
      let alertMessage = ERROR_WHILE_DELETING_FIELD;
      let responseData = error.response.data;
      FluentdHelper.logEvent(
        "Error while deleting the field",
        "RegisterPanel_handle_request_delete_field",
        user_email,
        {
          response:
            error.response.status === StatusCodes.BAD_REQUEST
              ? responseData
              : error,
        },
        LOGERROR
      );
      if (error.response.status === StatusCodes.BAD_REQUEST) {
        alertMessage = responseData.message;
        if (alertMessage.includes(SHARED_FIELD_WITH_OTHER_USER)) {
          alertMessage =
            SHARED_FIELD_WITH_OTHER_USER + CONTACT_ADMIN_TO_DELETE_FIELD;
        }
        setSubmitError(true);
        setErrorMessage(alertMessage);
        closeWarningPopup();
      } else {
        setShowConfirmPopup(false);
        setDeleteRecord(false);
        setSubmitError(true);
        setErrorMessage(ERROR_WHILE_DELETING_FIELD);
      }
    }
  };

  const _handle_delete_claimed_field = async (claim_id) => {
    let user_email = loggedInUser || registeredUser;
    try {
      await UserService.deleteClaimedField(claim_id);
      let claim_ids = JSON.parse(StorageHelper.getItem(CLAIM_IDS));
      if (claim_ids) {
        claim_ids = claim_ids.filter((c) => c !== claimIrrigUnitId.toString());
        StorageHelper.setItem(CLAIM_IDS, JSON.stringify(claim_ids));
      }
      setClaimId(EMPTY);
      setClaimIrrigUnitId(EMPTY);
      setShowConfirmPopup(false);
      setOverlayLoading(true);

      dispatch(clearSelectedField());
      props.removeWells();
      window.location.reload();
    } catch (error) {
      let responseData = error.response.data;
      FluentdHelper.logEvent(
        "Error while deleting the claim",
        "RegisterPanel_handle_delete_claimed_field",
        user_email,
        {
          response:
            error.response.status === StatusCodes.BAD_REQUEST
              ? responseData
              : error,
        },
        LOGERROR
      );
      if (error.response.status === StatusCodes.BAD_REQUEST) {
        setSubmitError(true);
        setErrorMessage(responseData.message);
        closeWarningPopup();
      } else {
        setSubmitError(true);
        setShowConfirmPopup(false);
        setDeleteRecord(false);
        setErrorMessage(ERROR_WHILE_DELETING_FIELD);
      }
    }
  };
  const closeWarningPopup = () => {
    setShowConfirmPopup(false);
    setConfirmPopupMessage(EMPTY);
    setDeleteRecord(false);
    setHeader(EMPTY);
    setFieldId(EMPTY);
    setGuid(EMPTY);
    setIndex(EMPTY);
    setIrrig_unit_Id(EMPTY);
    setClaimId(EMPTY);
    setClaimIrrigUnitId(EMPTY);
    setEditRecord(false);
  };

  const handleDeleteClick = async (irrig_unit_Id, idx, fieldName) => {
    const validSession = await SessionHelper.handleRefreshToken();
    if (validSession === true) {
      setShowConfirmPopup(true);
      setDeleteRecord(true);
      setNoActionRequired(true);
      setHeader("Remove Field");
      setConfirmPopupMessage(
        REMOVE_SELECTED_FIELD_CONFIRMATION + " '" + fieldName + "' ?"
      );
      setIrrig_unit_Id(irrig_unit_Id);
      setIndex(idx);
    }
  };

  const handleRegisteredDeleteClick = async (
    field_id,
    idx,
    guid,
    fieldIrrigUnitid,
    fieldName
  ) => {
    const validSession = await SessionHelper.handleRefreshToken();
    if (validSession === true) {
      setShowConfirmPopup(true);
      setDeleteRecord(true);
      setHeader("Remove Field");
      setConfirmPopupMessage(
        REMOVE_REGISTERED_FIELD_CONFIRMATION + " '" + fieldName + "' ?"
      );
      setFieldId(field_id);
      setGuid(guid);
      setIndex(idx);
    }
  };

  const handleClaimDeleteClick = async (
    claim_id,
    claim_irrig_unit_id,
    fieldName
  ) => {
    const validSession = await SessionHelper.handleRefreshToken();
    if (validSession === true) {
      setShowConfirmPopup(true);
      setDeleteRecord(true);
      setHeader("Remove Field");
      setConfirmPopupMessage(
        REMOVE_CLAIMED_FIELD_CONFIRMATION + " '" + fieldName + "' ?"
      );
      setClaimId(claim_id);
      setClaimIrrigUnitId(claim_irrig_unit_id);
    }
  };

  const handleEditClick = (e, irrig_unit_Id, idx) => {
    props.fillFieldDetails(e, irrig_unit_Id, idx);
  };

  const panelToggle = () => {
    props.latLongIntialState();
    props.panelToggle();
  };

  const handleRegisterEditClick = (
    e,
    fieldIrrigUnitid,
    guid,
    fieldId,
    fieldProperties
  ) => {
    props.PanelHide();
    props.latLongIntialState();
    if (AddedFields.length > 0) {
      setShowConfirmPopup(true);
      setEditRecord(true);
      setHeader("Warning");
      setNoActionRequired(false);
      setConfirmPopupMessage({ ADDED_FIELDS_WARNING });
    } else {
      props.fillRegisteredFieldDetails(
        e,
        fieldIrrigUnitid,
        guid,
        fieldId,
        fieldProperties
      );
    }
  };

  const handleAccordionClick = (e) => {
    dispatch(addedField(null));
    setToggleArrow(!toggleArrow);
    setOpenedPanel(e);
  };

  const handleHighlightField = (e, irrig_unit_Id, currentRecord) => {
    e.preventDefault();
    e.stopPropagation();
    for (let i = 0; i < AddedFields.length; i++) {
      if (AddedFields[i].irrig_unit_Id === irrig_unit_Id) {
        const coords = GoogleMapHelper.getPolygonCenter(
          AddedFields[i].irrigUnit
        );
        props.fieldHighlight(
          coords,
          500,
          AddedFields[i].irrig_unit_Id,
          SELECTED,
          AVAILABLE
        );
        break;
      }
    }
  };

  const showFieldOnMAP = (
    e,
    value,
    multi,
    color1,
    color2,
    fieldIrrigUnitid
  ) => {
    e.preventDefault();
    e.stopPropagation();
    props.fieldHighlight(value, multi, fieldIrrigUnitid, color1, color2);
  };

  const closeAlert = () => {
    setSubmitError(false);
  };

  const getGeometry = (irrig_unit_id) => {
    if (AllPolygons.hasOwnProperty("features")) {
      let geometry = _.find(AllPolygons.features, (field) => {
        return field.properties.irrig_unit_id === irrig_unit_id;
      });
      return geometry;
    } else {
      return null;
    }
  };

  const { allUserRegisteredFields, userClaimedFields } = props;

  let fieldsAdded = [];
  let userRegisteredField = [];
  let claimFields = [];
  let indexValue = 0;
  let j = 0;
  const openedPanelStatus =
    SelectedFieldAdded === true ? ADDED_FIELDS : openedPanel;

  if (
    allUserRegisteredFields &&
    Object.keys(allUserRegisteredFields).length > 0
  ) {
    const sortedUsersFields = allUserRegisteredFields.data.sort(function (
      a,
      b
    ) {
      if (a.field_name.toLowerCase() < b.field_name.toLowerCase()) {
        return -1;
      }
      if (a.field_name.toLowerCase() > b.field_name.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    for (j = 0; j < sortedUsersFields.length; j++) {
      let geomObject = getGeometry(sortedUsersFields[j].irrig_unit_id);
      if (geomObject) {
        sortedUsersFields[j]["geometry"] = geomObject.geometry;
      }
      const coords = GoogleMapHelper.getPolygonCenter(sortedUsersFields[j]);

      userRegisteredField.push(
        <PanelRegisteredField
          key={indexValue + sortedUsersFields[j].field_id}
          currentRecord={j}
          indexValue={indexValue}
          sortedUsersField={sortedUsersFields[j]}
          coords={coords}
          btnSubmitClick={btnSubmitClick}
          showFieldOnMAP={showFieldOnMAP}
          handleRegisterEditClick={handleRegisterEditClick}
          handleRegisteredDeleteClick={handleRegisteredDeleteClick}
        />
      );
    }
  }

  const sortedAddedFields = AddedFields.sort(function (a, b) {
    if (a.fieldName.toLowerCase() < b.fieldName.toLowerCase()) {
      return -1;
    }
    if (a.fieldName.toLowerCase() > b.fieldName.toLowerCase()) {
      return 1;
    }
    return 0;
  });

  for (let i = 0; i < sortedAddedFields.length; i++) {
    let wells = [];
    for (j = 0; j < sortedAddedFields[i].wells.length; j++) {
      let well_details = sortedAddedFields[i].wells[j];
      if (sortedAddedFields[i].wells.length === 1) {
        wells.push(
          <li key={j + 5000}>
            <ul>
              Well GPM: {well_details.gpm}
              {well_details.ugpm !== well_details.gpm ? (
                <li key={j}> &#9702; Updated GPM: {well_details.ugpm}</li>
              ) : (
                EMPTY
              )}
            </ul>
          </li>
        );
      } else {
        wells.push(
          <li key={"li_key" + Math.random()}>
            <ul>
              {"Well " + (j + 1)} GPM: {well_details.gpm}
              {well_details.ugpm !== well_details.gpm ? (
                <li key={j}> &#9702; Updated GPM: {well_details.ugpm}</li>
              ) : (
                EMPTY
              )}
            </ul>
          </li>
        );
      }
    }
    let acres = 0;
    if (sortedAddedFields[i] && sortedAddedFields[i].irrigUnit.properties) {
      acres = sortedAddedFields[i].irrigUnit.properties.acres;
    }
    acres = acres.toFixed(2);

    fieldsAdded.push(
      <PanelAddedField
        key={indexValue}
        currentRecord={i}
        indexValue={indexValue}
        btnSubmitClick={btnSubmitClick}
        sortedAddedField={sortedAddedFields[i]}
        acres={acres}
        wells={wells}
        noOfFields={sortedAddedFields.length}
        handleEditClick={handleEditClick}
        handleDeleteClick={handleDeleteClick}
        handleHighlightField={handleHighlightField}
      />
    );
    indexValue += 1;
  }
  if (userClaimedFields && Object.keys(userClaimedFields).length > 0) {
    const sortedUserClaimFields = userClaimedFields.data.sort(function (a, b) {
      if (a.claim_field_name.toLowerCase() < b.claim_field_name.toLowerCase()) {
        return -1;
      }
      if (a.claim_field_name.toLowerCase() > b.claim_field_name.toLowerCase()) {
        return 1;
      }
      return 0;
    });

    for (j = 0; j < sortedUserClaimFields.length; j++) {
      let geomObject = getGeometry(
        sortedUserClaimFields[j].claim_irrig_unit_id
      );
      if (geomObject) sortedUserClaimFields[j].geometry = geomObject.geometry;

      const coords = GoogleMapHelper.getPolygonCenter(sortedUserClaimFields[j]);

      claimFields.push(
        <PanelClaimedField
          key={indexValue + sortedUserClaimFields[j].claim_id}
          indexValue={indexValue}
          sortedUserClaimField={sortedUserClaimFields[j]}
          coords={coords}
          btnSubmitClick={btnSubmitClick}
          showFieldOnMAP={showFieldOnMAP}
          handleClaimDeleteClick={handleClaimDeleteClick}
        />
      );
    }
  }

  return (
    <aside
      className={
        props.panelStatus
          ? "sidebar register-panel"
          : "sidebar register-panel hide-sidebar"
      }
    >
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text="Loading..."
      />
      {submitError ? (
        <div className="alert-message ">
          <Alert
            key="messageAlert"
            variant={DANGER}
            closeAlert={(e) => closeAlert(e)}
            alertMessage={errorMessage}
            dismissible
          />
        </div>
      ) : (
        EMPTY
      )}

      <Accordion defaultActiveKey={openedPanelStatus}>
        <div className="hide-panel" onClick={(e) => panelToggle()}>
          <b className="close">{props.panelStatus ? ">" : "<"}</b>
        </div>
        <Accordion.Item eventKey={ADDED_FIELDS}>
          <Accordion.Header>
            Fields Added ({sortedAddedFields.length})
          </Accordion.Header>
          <Accordion.Body className="scroll-panel">
            {fieldsAdded}
            {fieldsAdded.length > 0 ? (
              <Button
                onClick={() => _handle_submit_registration_request()}
                disabled={btnSubmitClick}
              >
                {btnSubmitClick ? (
                  <div>
                    <Spinner
                      as="div"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    Submitting...
                  </div>
                ) : (
                  "Submit"
                )}
              </Button>
            ) : (
              "Please add fields"
            )}
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey={REGISTERED_FIELDS}>
          <Accordion.Header>
            Registered Fields ({userRegisteredField.length})
          </Accordion.Header>

          <Accordion.Body className="scroll-panel">
            {userRegisteredField}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={CLAIMED_FIELDS}>
          <Accordion.Header>
            Claimed Fields ({claimFields.length})
          </Accordion.Header>

          <Accordion.Body className="scroll-panel">
            {claimFields}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      {(deleteRecord || editRecord) && (
        <ConfirmPopup
          showConfirmPopup={showConfirmPopup}
          message={confirmPopupMessage}
          addedFieldStatus={AddedFields.length}
          closeWarningPopup={(e) => closeWarningPopup(e)}
          performWarningAction={(e) => performWarningAction(e)}
          header={header}
          irrig_unit_Id={irrig_unit_Id}
          noActionRequired={noActionRequired}
          disableButton={true}
        />
      )}
    </aside>
  );
}

export default RegisterPanel;
